import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  OffsetCollectionConfig,
  useWixPatternsContainer,
  useCreateCollection,
} from '@wix/bex-core/react';
import { InfiniteScrollTableState } from '../state';

/**
 * @deprecated use useTable instead
 */
export function useOffsetInfiniteScrollTable<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: OffsetCollectionConfig<T, F>) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new InfiniteScrollTableState({
        collection: createCollection<T, F>({
          ...config,
          paginationMode: 'offset',
        }),
        container,
      }),
  );

  return state;
}
